/**
 * 文件功能：axios 请求封装（统一 baseURL、超时时间与响应拦截）
 * 输入参数：无（读取环境变量 VUE_APP_BASEURL 作为后端接口地址）
 * 输出参数：无
 * 返回值：导出配置好的 axios 实例
 * 说明：响应拦截器剥离 AxiosResponse 外壳，直接返回业务数据（response.data）。
 */
import axios,{Axios,AxiosResponse,AxiosRequestConfig} from 'axios'
declare module "axios" {
    interface AxiosResponse<T = any> {
        errorinfo: null;
        code: number;
        msg:string;
    }
}
// 创建一个新的axios对象
const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,   // 后端的接口地址  http://localhost:9090
    timeout: 30000,
})

// request 拦截器
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    // FormData（文件上传）时保留 axios 自动生成的 multipart Content-Type（含 boundary），
    // 其余请求统一 JSON
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    return config
}, error => {
    console.error('request error: ' + error) // for debug
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;

        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.error('response error: ' + error) // for debug
        return Promise.reject(error)
    }
)


export default request
